<template>
  <el-dialog title="审批意见" :visible="dialogFormVisible" :before-close="handleClose">
    <p class="res">{{text}}</p>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["dialogVisible", "text"], //falg判断是联系人、负责人

  data() {
    return {
      dialogFormVisible: false
    };
  },

  methods: {
    handleClose() {
      this.dialogFormVisible = false;
      this.$emit("closeDialog");
    }
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue;
    }
  }
};
</script>

<style scoped>
.res {
  font-size: 14px;
  color: #6c7885;
  height: 300px;
  overflow-y: auto;
}
</style>


